module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_c('strong', [_vm._v("Pompom Cushion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_c('strong', [_vm._v("Bright Stripe Pillows")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_c('strong', [_vm._v("Beaded Cushion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_c('strong', [_vm._v("Black and White Pillow")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_c('strong', [_vm._v("Vibrant Seating Cube")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_c('strong', [_vm._v("Fringed Ribbon Pillow")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_c('strong', [_vm._v("French Knitted Cushions")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_c('strong', [_vm._v("Blooming Rose Pillow")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_c('strong', [_vm._v("Diamond Pattern Pillow")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_c('strong', [_vm._v("Bunting Cushion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cmtech.htm"
    }
  }, [_c('strong', [_vm._v("Cushion-Making Techniques")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ftech.htm"
    }
  }, [_c('strong', [_vm._v("Finishing Techniques")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ktech.htm"
    }
  }, [_c('strong', [_vm._v("Knitting Techniques")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/abb.htm"
    }
  }, [_c('strong', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/term.htm"
    }
  }, [_c('strong', [_vm._v("US/UK Terms")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/syw.htm"
    }
  }, [_c('strong', [_vm._v("Standard Yarn Weights")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/emsk.htm"
    }
  }, [_c('strong', [_vm._v("Enjoy more Simple Knits")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_c('strong', [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0